// Minnesotaänger Mini App — v1 message date helpers.
// New code (not from telegram-tt). telegram-tt's date formatters take a
// LangFn; v1 formats via Intl under the browser's locale, falling back to
// zh-CN (v1's strings are zh-CN and non-browser contexts have no navigator).

// The locale is fixed at module load: v1 has no language switcher, and
// Intl formatters are expensive to rebuild per render.
function resolveLocale(): string {
  return typeof navigator !== 'undefined' && navigator.language ? navigator.language : 'zh-CN';
}

const LOCALE = resolveLocale();

const TIME_FORMATTER = new Intl.DateTimeFormat(LOCALE, {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

const DATE_FORMATTER = new Intl.DateTimeFormat(LOCALE, {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
});

const MONTH_DAY_FORMATTER = new Intl.DateTimeFormat(LOCALE, {
  month: 'long',
  day: 'numeric',
});

// Local day key ("2026-08-08") used to group messages into date sections.
export function getDayKey(isoDate: string): string {
  const date = new Date(isoDate);
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

// Bubble timestamp: "14:05".
export function formatMessageTime(isoDate: string): string {
  return TIME_FORMATTER.format(new Date(isoDate));
}

// Date separator: "今天" / "昨天" / "8月8日" (with year when it differs).
export function formatMessageDate(isoDate: string): string {
  const date = new Date(isoDate);
  const now = new Date();
  const todayKey = getDayKey(now.toISOString());
  const dateKey = getDayKey(isoDate);

  if (dateKey === todayKey) {
    return '今天';
  }

  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (dateKey === getDayKey(yesterday.toISOString())) {
    return '昨天';
  }

  return date.getFullYear() === now.getFullYear()
    ? MONTH_DAY_FORMATTER.format(date)
    : DATE_FORMATTER.format(date);
}

// Conversation list row time: "14:05" for today, "8月8日" otherwise.
export function formatConversationTime(isoDate: string): string {
  const date = new Date(isoDate);
  if (getDayKey(isoDate) === getDayKey(new Date().toISOString())) {
    return TIME_FORMATTER.format(date);
  }
  return MONTH_DAY_FORMATTER.format(date);
}
